/* External */
import { memo, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

/* Other */
import { getJsonImage } from 'src/theme/images';
import { hideModal, showModal } from '../../storage/modal';
import { selectShowModal } from '../../storage/modal/selectors';

/* Theme Assets */
import logoDgoSkymais from '../../assets/svg/logos-dgo-skymais.svg';

/* Components */
import Modal from '../Modal';
import ContentModal from './ContentModal';

/* Utils */
import {
  WARNING_TEXTS_DGO_SKYMAIS,
  STORAGE_SHOW_WARNING_DGO_SKYMAIS,
} from '../../utils/constants';
import withInteractiveFocusable from '../../hocs/withInteractiveFocusable.hoc';
import { useIsBrazil } from '../../providers/ConfigProvider';
import platform from '../../utils/platform';
import { redirectTo } from '../../utils/history';
import { getPath, Routes } from '../../utils/router';
import {
  IS_FIRST_WARNING_DGO_SKYMAIS_ACTIVE,
  IS_SECOND_WARNING_DGO_SKYMAIS_ACTIVE,
} from '../../utils/env';

/* Styles */
import './SkyMaisModal.scss';

function SkyMaisModal() {
  const isBrazil = useIsBrazil();
  const dispatch = useDispatch();
  const isModalShown = useSelector(selectShowModal);
  const backgroundOpacity = platform.isTizen || IS_FIRST_WARNING_DGO_SKYMAIS_ACTIVE;

  const handleLogoutApp = useCallback(() => {
    redirectTo(getPath(Routes.Logout));
  }, []);

  const handleCloseModal = useCallback(() => {
    localStorage.setItem(STORAGE_SHOW_WARNING_DGO_SKYMAIS, JSON.stringify(false));
    dispatch(hideModal());
  }, [dispatch]);

  let selectedContentModal;
  if (isBrazil) {
    if (IS_FIRST_WARNING_DGO_SKYMAIS_ACTIVE) {
      selectedContentModal = platform.isTizen
        ? WARNING_TEXTS_DGO_SKYMAIS.firstWarning.tizen
        : WARNING_TEXTS_DGO_SKYMAIS.firstWarning.default;
    } else if (IS_SECOND_WARNING_DGO_SKYMAIS_ACTIVE) {
      selectedContentModal = platform.isTizen
        ? WARNING_TEXTS_DGO_SKYMAIS.secondWarning.tizen
        : WARNING_TEXTS_DGO_SKYMAIS.secondWarning.default;
    }
  }

  const onEnterPress = (
    IS_FIRST_WARNING_DGO_SKYMAIS_ACTIVE
      || (IS_SECOND_WARNING_DGO_SKYMAIS_ACTIVE && platform.isTizen)
  ) ? handleCloseModal : handleLogoutApp;

  const { title, description, textButton } = selectedContentModal || {};

  useEffect(() => {
    dispatch(showModal());
  }, [dispatch]);

  return (
    <Modal
      isModalShown={isModalShown}
      backgroundOpacity={backgroundOpacity}
    >
      <ContentModal
        logo={getJsonImage('logos-dgo-skymais') || logoDgoSkymais}
        title={title}
        description={description}
        textButton={textButton}
        isModalShown={isModalShown}
        onEnterPress={onEnterPress}
      />
    </Modal>
  );
}

export default memo(withInteractiveFocusable()(memo(SkyMaisModal)));
